NtechApp.AcceptNewTeamMemberForm = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._form = null;
    this._formDataParser = null;

    this._submitLoader = null;

    this._positionsData = null;
    this._positionsSelect = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._formDataParser = new NtechApp.FormDataParser();

        me._bindEvents();
    }

    this._bindEvents = function() {
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.AcceptNewTeamMemberForm.EVENT_MEMBER_ADDED = "NtechApp.AcceptNewTeamMemberForm.EventMemberAdded";

NtechApp.proto(NtechApp.AcceptNewTeamMemberForm, {
    loadForm: function(teamMemberId) {
        var me = this;

        me._form = new NtechApp.ModalForm();
        me._form.load('business_dashboard_load_accept_join_team_request_form', {teamMemberId: teamMemberId}, function($form) {
            me._bindFormEvents.call(me, $form);
        });
    },

    _bindFormEvents: function($form) {
        var me = this;

        var positionsData = $form.find("[data-packedPositions]").attr("data-packedPositions");
        var catsData = positionsData.split("_");

        positionsData = {};
        for(var i = 0; i < catsData.length; i++) {
        	var entitiesData = catsData[i].split("|");
        	for(var j = 0; j < entitiesData.length; j++) {
        		var entityData = entitiesData[j].split(";");
        		if(!NtechApp.dom.hasOwnProp(positionsData, entityData[1]))
        			positionsData[entityData[1]] = [];

        		positionsData[entityData[1]].push({
        			name: entityData[0],
        			positionType: entityData[1],
        			isPositionWithCustomName: entityData[2],
        			id: entityData[3]
        		});
        	}
        }
        
        me._positionsData = positionsData;
        me._createSelect($form);
        me._selectPositionCategory($form.find(".selectListItem").filter(function() { return $(this).hasClass("selected"); }));

        $(me._positionsSelect).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function(e, label, val) {
        	me._updatePositionCustomNameField($form, val);
        });

        me._click.listen($form.find("[data-packedPositions]"), ".selectListItem", function(e) {
        	var $item = $(e.target).closest(".selectListItem");
        	if($item.hasClass("selected"))
        		return;

        	$form.find(".selectListItem").removeClass("selected");
        	$item.addClass("selected");

        	me._selectPositionCategory($item);
        	me._updatePositionCustomNameField($form, "");

        	me._positionsSelect.clearVal();
        });

        me._click.listen($form.find(".formHeader .close .button"), function(event) {
            me._unloadForm();
        });

        me._submitLoader = new NtechApp.Loader(18, 18, "absolute", $form.find("[data-formSubmit]"));
        me._submitLoader.getView().css({
            background: '#37bdb1',
            borderRadius: '9px'
        });

        me._click.listen($form, "[data-formSubmit]", function(e) {
            if($(e.target).closest(".formControl").find(".ntechapp-loader").hasClass("visible"))
                return;

            me._saveJoinTeamForm($form);
        });

        me._click.listen($form, ".formErrors", function() {
            $form.find(".formErrors").css("display", "none");
        });
    },

    _createSelect: function($form) {
    	var me = this;
    	this._positionsSelect = new NtechApp.SelectForm(
            $form.find("#accept_new_team_member_position")
        );
        this._positionsSelect.setOverlayCss({zIndex: 1300});
        this._positionsSelect.getForm().css({zIndex: 1400});

        this._click.listen(this._positionsSelect.getView(), function() {
            me._positionsSelect.on();
        });
    },

    _selectPositionCategory: function($selectListItem) {
    	var selectedPositionType = $selectListItem.attr("data-selectListVal");
    	var selectPositionsData = this._positionsData[selectedPositionType];

    	var labels = [];
    	var vals = [];
    	for(var i = 0; i < selectPositionsData.length; i++) {
    		labels.push(selectPositionsData[i].name);
    		vals.push(selectPositionsData[i].id);
    	}

    	this._positionsSelect.reinsertOptions(labels, vals);
    },

	_updatePositionCustomNameField: function($form, val) {
		var me = this;
    	var data = null;

    	for(var positionType in me._positionsData) {
    		var entitiesData = me._positionsData[positionType];
    		for(var i = 0; i < entitiesData.length; i++) {
    			if(entitiesData[i].id == val)
    				data = entitiesData[i];
    		}
    	}

    	if(data == null) {
    		data = {isPositionWithCustomName: false};
    	}

    	var $positionCustomNameInput = $form.find("#accept_new_team_member_positionCustomName");
    	if(parseInt(data.isPositionWithCustomName, 10)) {
    		$positionCustomNameInput.val("");
    		$positionCustomNameInput.css("display", "block");
    	}
    	else {
    		$positionCustomNameInput.val("");
    		$positionCustomNameInput.css("display", "none");
    	}
    },

    _unloadForm: function() {
        var me = this;
        me._form.unload();
    },

    _enableLoader: function() {
        this._submitLoader.on().white();
    },

    _disableLoader: function() {
        this._submitLoader.off();
    },

    _showErrors: function($form, errors) {
        var me = this;
        var $errors = $form.find(".formErrors");

        $errors.css("display", "block");
        $errors.find(".errorBody > p").remove();

        for(var errorName in errors)
            $errors.find(".errorBody").append("<p>" + errors[errorName] + "</p>");
    },

    _saveJoinTeamForm: function($form) {
        var me = this;
        me._enableLoader();

        var formData = this._formDataParser.getFormJSON($form.find("form"));

        var params = {
            formData: formData
        };
        params.formData.teamMemberId = $form.attr("data-teamMemberId");

        me._ajax.post({
            url: Routing.generate('business_dashboard_save_accept_join_team_request_form'),
            data: params,
            onSuccess: function(data) {
                $(me).trigger(NtechApp.AcceptNewTeamMemberForm.EVENT_MEMBER_ADDED, [
                	data.memberAccountFullname, data.memberPositionName, data.teamMemberId
                ]);
                me._unloadForm();

                NtechApp.info.on(data.memberAccountFullname + " successfully added to team as " + data.memberPositionName + ".", 2500);
            },
            onError: function(errors) {
                me._disableLoader();
                me._showErrors($form, errors);
            }
        });
    }
});